import { useState } from 'react';
import { ClientAccount, ClientAccountListRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

/** Lists client accounts, as the session's account or, given a `bearer` JWT, as that account. */
export default function useFetchClientAccounts() {
  const api = useApi();
  const [fetchingClientAccounts, setFetchingClientAccounts] = useState(false);
  const [clientAccounts, setClientAccounts] = useState<ClientAccount[]>([]);

  async function fetchClientAccounts(params: ClientAccountListRequest, bearer?: string) {
    try {
      setFetchingClientAccounts(true);
      const res = await api.fetchClientAccountList(params, undefined, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setClientAccounts(res.ClientAccounts);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingClientAccounts(false);
    }
  }

  return { fetchingClientAccounts, clientAccounts, fetchClientAccounts };
}
